
const settings = {}
Object.keys(process.env)
  .forEach((k) => {
    if (k.includes('NODE_')) return
    let name = k
    if (k.includes('VUE_APP_')) {
      name = k.split('VUE_APP_')[1]
    }
    settings[name] = process.env[k]
  })

export default settings
